import { render, staticRenderFns } from "./Prescription.vue?vue&type=template&id=864b4a4c&lang=pug"
import script from "./Prescription.vue?vue&type=script&lang=js"
export * from "./Prescription.vue?vue&type=script&lang=js"
import style0 from "./Prescription.vue?vue&type=style&index=0&id=864b4a4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports